import React, { useEffect, useState } from "react";

import axios from "axios";
import { IntlProvider } from "react-intl";
import TopBarProgress from "react-topbar-progress-indicator";
import { useRouter } from "next/dist/client/router";
import AOS from "aos";
import SSRProvider from "react-bootstrap/SSRProvider";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.rtl.min.css";

import "aos/dist/aos.css";

import "../styles/main.scss";

import Header from "../src/components/Layout/Header";
import Footer from "../src/components/Layout/Footer";
import Socials from "../src/components/Layout/Socials";
import Loading from "../src/components/Shared/Loading";

const languages = {
  ar: require("../src/content/languages/ar.json"),
  en: require("../src/content/languages/en.json"),
};

import Head from "next/head";
import server, { getProjects } from "../src/api/server";

function MyApp({ Component, pageProps, companyProfile, ...rest }) {
  const [Progress, setProgress] = useState(false);
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  // const [initData, setInitData] = useState({});
  const initData = rest;

  TopBarProgress.config({
    barThickness: 3,
    barColors: {
      0: "#082331",
      0.5: "#082331",
      1.0: "#082331",
    },
  });

  useEffect(() => {
    const handleStart = (url) => {
      url !== router.pathname ? setLoading(true) : setLoading(false);
    };
    const handleComplete = (url) => setLoading(false);

    router.events.on("routeChangeStart", () => {
      handleStart();
      setProgress(true);
    });
    router.events.on("routeChangeComplete", () => {
      handleComplete();
      setProgress(false);
    });
    router.events.on("routeChangeError", handleComplete);
  }, [router]);

  const { locale, defaultLocale } = useRouter();
  const messages = languages[locale];
  const dir = locale === "ar" ? "rtl" : "ltr";

  // Direction & AnimationOnScroll
  useEffect(() => {
    AOS.init({
      once: true,
      disable: "mobile",
    });
    document.documentElement.dir = dir;
    document.body.style.direction = dir;
    document.body.setAttribute("dir", dir);
  }, [dir]);

  // Get Data
  // useEffect(() => {
  //   const getData = async () => {
  //     const socialsResponse = await server.get("/settings/socials");
  //     const mapFrameResponse = await server.get("/settings/siteInfo");
  //     const projects = await getProjects();
  //     setInitData({
  //       socials: socialsResponse?.data?.data?.socials,
  //       siteInfo: mapFrameResponse?.data?.data?.siteInfo,
  //       projects,
  //     });
  //   };
  //   getData();
  // }, []);
  //

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>
          {initData?.siteInfo?.appName?.[locale] ||
            "وليد بن عبد العزيز بن موزان | Walid bn abdelaziz bn mozan"}
        </title>
        <link rel="shortcut icon" href="/favicon.ico" />

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-17502943741"
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17502943741');
      `,
          }}
        />
      </Head>
    

      {Progress && <TopBarProgress />}
      <Loading loading={loading} />
      <IntlProvider
        messages={messages}
        defaultLocale={defaultLocale}
        locale={locale}
      >
        <SSRProvider>
          <div className="wrap">
            <Header companyProfile={companyProfile} {...{ initData }} />
            <Socials {...{ initData }} />
            <Component {...pageProps} />
            <Footer {...{ initData }} />
          </div>
        </SSRProvider>
      </IntlProvider>
    </>
  );
}

MyApp.getInitialProps = async () => {
  const socialsResponse = await server.get("/settings/socials");
  const companyProfile = await server.get("/pages/companyProfile");
  const mapFrameResponse = await server.get("/settings/siteInfo");
  const projects = await getProjects();

  return {
    companyProfile: companyProfile?.data?.data?.page?.sections?.[0],
    socials: socialsResponse?.data?.data?.socials,
    siteInfo: mapFrameResponse?.data?.data?.siteInfo,
    projects,
  };
};

export default MyApp;
